import View       from 'scripts/poppet/view'
import template   from './template-notifications-menu-view.jst.html'

const selectors = {
	navButtons: '[data-click^=nav-]'
};


export const NotificationsMenuView = View.extend({
	template,
	ui: {
		navButtons: selectors.navButtons
	},
	events: {
		'click @ui.navButtons': 'onClickNavButtons'
	},
	
	onClickNavButtons: function(event) {
		event.preventDefault();
		let $target = $(event.target).closest(selectors.navButtons);
		let command = $target.attr('data-click').replace('nav-', '');
		this.trigger('nav', command);
		console.log('you clicked', event, command)
	}
});

export default NotificationsMenuView;